import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface Props {
  role?: "viewer" | "team";
  children: JSX.Element;
}

const ProtectedRoute: React.FC<Props> = ({ role, children }) => {
  const { user } = useAuth();

  if (!user) return <Navigate to="/signin" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
